// Pagination Component

<template>
  <div>
    <div class="pagination">
      <div class="pagination__item" @click="pageChange(1)">
        <font-awesome-icon icon="fa-solid fa-angles-left" />
      </div>
      <div class="pagination__item" @click="pageChange(currentPage - 1)">
        <font-awesome-icon icon="fa-solid fa-angle-left" />
      </div>
      <div class="pagination__item" v-for="page in pages" :key="page" @click="pageChange(page)">
        <span :class="[page === currentPage ? 'active' : 'inactive']">{{ page }}</span>
      </div>
      <div class="pagination__item" @click="pageChange(currentPage + 1)">
        <font-awesome-icon icon="fa-solid fa-angle-right" />
      </div>
      <div class="pagination__item" @click="pageChange(totalPages)">
        <font-awesome-icon icon="fa-solid fa-angles-right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationComponent",
  props: {
    totalRecords: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    pagesToShow: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(Number(this.totalRecords / this.pageSize));
    },
    pages() {
      let pages = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    pageChange(page) {
      if (page < 1 || page > this.totalPages) {
        return;
      }
      this.currentPage = page;
      this.$emit("pageChange", page);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
  .pagination__item {
    padding: 5px 10px;
    font-size: $font-size-md;
    border: 2px solid $border-color;
    border-radius: 5px;
    margin: 0 5px;
    cursor: pointer;
    &:hover {
      background-color: $light-fade-100;
    }
  }
}
.fa-angles-left,
.fa-angles-right,
.fa-angle-left,
.fa-angle-right {
  font-size: $font-size-md;
}

.active {
  color: $primary-100;
  font-weight: 600;
}

.inactive {
  color: $light-400;
  font-weight: 400;
}
</style>
